import { render, staticRenderFns } from "./ApprovalReward.vue?vue&type=template&id=3db067a3&"
import script from "./ApprovalReward.vue?vue&type=script&lang=js&"
export * from "./ApprovalReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports